// The on-ramp offer on the card (R3075; ui-map-interface.md §8 "The
// on-ramp offer"). After a MOVE that a shipping lane of the faction serves
// faster, the card of the own fleet offers the lane course in one row, in
// the layout of the signature order row (`approach.ts`): the quiet press
// VIA LANE with the key cap of shift with v, and beside it "via <lane> ·
// saves <time>". The time is the saving on the map clock, printed in
// world time as every duration on the card is. The closed context sheet
// of a telephone draws the row too, so one tap takes the lane. The
// module is pure; `laneoffer.ts` of `src/` holds the offers.

import { card as S } from '../../gen/strings';
import { signatureRowHtml } from './approach';

/** The act of the VIA LANE press: the lane course for the hull. */
export const LANE_OFFER_ACT = 'laneoffer';

/** The row of an offer: `lane` names the lane, `save` is the time it
 *  saves as the card prints a time, `key` the key cap. */
export function laneOfferRowHtml(fleetId: number, lane: string, save: string, key: string): string {
  return signatureRowHtml({
    act: LANE_OFFER_ACT, id: fleetId, face: 'quiet', label: S.o_lane,
    title: S.lane_offer_title({ lane }), key,
  }, S.lane_offer({ lane, dur: save }), '');
}
